/*
 * @Author: your name
 * @Date: 2022-02-21 13:24:33
 * @LastEditTime: 2022-09-18 20:16:06
 * @LastEditors: zhaoyu zhaoyu@belink.com
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \pscd-portal-www\packages\clients\store.ts
 */
import lodash from 'lodash';
import { EnumAPI } from './apis';
import * as Controller from './controller';
import Env from './env';
import { AjaxBasics, IAjaxConfig, Log } from './helpers';
export function createStore() {
  const UserInfo = new Controller.UserInfoController();
  const Store = {
    /** 系统 登陆注册 */
    System: new Controller.SystemController(),
    /** 用户信息 */
    UserInfo,
    /** 分享 */
    Share: new Controller.ShareController(),
    /** 账号中心 */
    AccountCenter: new Controller.AccountCenterController(),
    /** 微信 */
    Wechat: new Controller.WechatController(Env.appid),
    /** 账户信息 */
    Account: new Controller.AccountController(),
    /** 非业务公共 */
    Currency: new Controller.CurrencyController(),
    /** 产品 */
    Product: new Controller.ProductController(),
    /** 广告 */
    ADS: new Controller.ADSController(),
    /** 热门 */
    Hot: new Controller.HotController(),
    /** 交易 */
    Trading: new Controller.TradingController(),
    /** 信息 */
    Information: new Controller.InformationController(),
    /** 商机 */
    Business: new Controller.BusinessController(),
    /** 反馈 */
    Feekback: new Controller.FeekbackController(),
    /** 海报 */
    Poster: new Controller.PosterController(),
    /** isg */
    Isg: new Controller.IsgController(),
    /** 合作伙伴/留资 */
    Cooperate: new Controller.CooperateController(),
    /** 平台配置 */
    Platform: new Controller.PlatformController(),
    /** 法务弹框 */
    LegalScreen: new Controller.LegalScreenController(),
    /** 创建响应头 */
    // createHeaders: createHeaders,
    /** Ajax */
    Ajax: new AjaxBasics({ merge }),
    Smb: new Controller.SmbController(),
    Xiaozhi: new Controller.XiaozhiController(),
    /** 推广 */
    ShareLink: new Controller.ShareLinkController(),
    OutagesNotice: new Controller.OutagesNoticeController(),
    /** 移动端个人中心 */
    MobilePersonalCenter: new Controller.MobilePersonalCenterController(),
    /** 客户端相关 */
    Client: new Controller.ClientController(),
  };
  /**
   * merge AjaxBasics
   * @param AjaxConfig
   * @returns
   */
  AjaxBasics.merge = merge;
  /**
   * merge
   * @param AjaxConfig
   * @returns
   */
  async function merge(AjaxConfig) {
    AjaxConfig = createHeaders(AjaxConfig);
    // 默认 所有请求都需要等待用户完成 带有标记 和 已完成 则跳过
    if (
      // 服务端不需要等待
      typeof window === 'undefined' ||
      lodash.eq(AjaxConfig.awaitAuthenticated, false) ||
      Store.System.Auth.HydrateisStopped
    ) {
      return AjaxConfig;
    }
    Log.warning(`等待用户初始化完成 【 ${AjaxConfig.url} 】`, AjaxConfig);
    await Store.System.Auth.HydrateAsync;
    AjaxConfig = createHeaders(AjaxConfig);
    return AjaxConfig;
  }
  /**
   * 创建响应头
   * @param AjaxConfig
   * @returns
   */
  function createHeaders(AjaxConfig: IAjaxConfig) {
    // 配置 token
    if (Store.System.AccessToken) {
      const isToken = lodash.some(['bpportal-mall'], (item) =>
        lodash.includes(AjaxConfig.url, item),
      );
      const tokenKey = isToken ? 'token' : 'bp-token';
      lodash.merge(AjaxConfig, {
        headers: { [tokenKey]: Store.System.AccessToken },
      });
    }
    const promoSource = Store.ShareLink.promoSource || Store.Share.promoSource;
    if (promoSource) {
      lodash.merge(AjaxConfig, {
        headers: { 'x-source-website': promoSource },
      });
    }
    const systemSource = lodash.get(AjaxConfig, 'body.systemSource');
    if (systemSource && lodash.includes([3, 31], systemSource)) {
      const promoCodeTarget = lodash.get(
        {
          release: {
            accountsvr_user_add: 'c2efe7bee85e4ea6a7b2556851c20742',
            orgidass_smb_register: '21a254dc6a7a429c83f3e6ba7940f370',
          },
        },
        Env.APP_ENV,
        {
          accountsvr_user_add: '4e8fc6e8ba0e4d20bb0a67a6a3658a5d',
          orgidass_smb_register: 'd83af8133bdc4ded9350870ca464b273',
        },
      );
      let promoCode = '';
      if (lodash.includes(AjaxConfig.url, EnumAPI.accountsvr_user_add.url)) {
        promoCode = promoCodeTarget.accountsvr_user_add;
      }
      if (lodash.includes(AjaxConfig.url, EnumAPI.orgidass_smb_register.url)) {
        promoCode = promoCodeTarget.orgidass_smb_register;
      }
      lodash.merge(AjaxConfig, {
        headers: {
          'x-bp-promo-code': promoCode,
          'x-source-website': 'LCIC',
        },
      });
    }
    // 分享码
    if (Store.Share.shareCode) {
      lodash.merge(AjaxConfig, {
        headers: { 'x-bp-promo-code': Store.Share.getHeaderValue() },
      });
    }
    // wechat openid
    if (Store.Wechat.openid) {
      lodash.merge(AjaxConfig, {
        headers: { 'x-wechat-openid': Store.Wechat.openid },
      });
    }
    if (Store.Wechat.weappOpenid || Store.Wechat.weappUnionId) {
      lodash.merge(AjaxConfig, {
        headers: {
          'x-wechat-info': `unionId=${Store.Wechat.weappUnionId};openId=${Store.Wechat.weappOpenid}`,
        },
      });
    }
    // BU
    if (!lodash.includes(AjaxConfig.url, '/idaas/public/v1/users/add')) {
      if (Store.System.User.BU) {
        lodash.merge(AjaxConfig, {
          headers: { 'x-business-unit': Store.System.User.BU },
        });
      }
    }
    // uid
    if (Store.Client.uid) {
      lodash.merge(AjaxConfig, {
        headers: { 'x-bp-client-id': Store.Client.uid },
      });
    }
    return AjaxConfig;
  }
  return Store;
}
